// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_nf-0";
export var animationContainer = "_nf-1";
export var itemPrice = "_nf-a";
export var itemizedContent = "_nf-9";
export var itemizedHeader = "_nf-7";
export var itemizedRow = "_nf-8";
export var itemizedSection = "_nf-6";
export var modalContent = "_nf-2";
export var orderName = "_nf-3";
export var refundOption = "_nf-4";
export var refundOptionsContainer = "_nf-5";
export var shippingLabel = "_nf-b";
export var totalRow = "_nf-c";